import type { Logger } from 'pino';

export const useLogger = (): Logger => {
  const { $logger } = useNuxtApp();
  return $logger as Logger; // Or throw an error if $logger is not defined
};
